module.exports = __webpack_public_path__ + "images/ac63f1a80d977331090947b4aff12c33.png";